import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
    private readonly versionUrl = 'assets/version.json';
    private readonly checkInterval = 2 * 60 * 1000; // every 5 minutes

    constructor(private http: HttpClient) { }

    initVersionCheck(): void {
        this.checkVersion();

        setInterval(() => {
            this.checkVersion();
        }, this.checkInterval);
    }

    private checkVersion(): void {
        this.http.get<{ version: string }>(this.versionUrl, { headers: { 'Cache-Control': 'no-cache' } })
            .subscribe({
                next: (res) => {
                    if (res.version !== environment.appVersion) {
                        console.warn(`🔄 New version detected (${res.version} ≠ ${environment.appVersion})`);
                        this.forceReload();
                    }
                },
                error: (err) => {
                    console.error('Could not fetch version.json:', err);
                }
            });
    }

    private forceReload(): void {
        console.log('🔄 Reloading application due to version change');
        // return;
        window.location.reload();
    }
}